import { Button, Space, Table, Tag } from 'antd'
import { useState, useEffect } from 'react'
import AuthComponent from '../../../../components/AuthComponent'
const ShipmentListTable = props => {
  const {
    dataSource = [],
    total,
    loading,
    rowSelection,
    page,
    type,
    onChange = () => {},
    optionsHandler = () => {}
  } = props
  const [width, setWidth] = useState(0)
  const [columns, setColumns] = useState([])
  useEffect(() => {
    if (columns && columns.length > 0) {
      const totalW = columns.map(w => w.width || 120).reduce((n, m) => n + m)
      setWidth(totalW)
    }
  }, [columns])

  useEffect(() => {
    if (type === '1') {
      setColumns([
        {
          title: '配送方式',
          dataIndex: 'receiveWay',
          key: 'receiveWay',
          align: 'center'
        },
        {
          title: '订单号',
          dataIndex: 'orderNo',
          key: 'orderNo',
          align: 'center'
        },
        {
          title: '订单类型',
          dataIndex: 'orderTypeName',
          key: 'orderTypeName',
          align: 'center'
        },
        {
          title: '下单时间',
          dataIndex: 'orderTime',
          key: 'orderTime',
          align: 'center'
        },
        {
          title: '收货人姓名',
          dataIndex: 'receiverName',
          key: 'receiverName',
          align: 'center'
        },
        {
          title: '收货地址',
          dataIndex: 'receiverDetailAddr',
          key: 'receiverDetailAddr',
          align: 'left'
        },
        {
          title: '收货人电话',
          dataIndex: 'receiverPhone',
          key: 'receiverPhone',
          align: 'center'
        },
        {
          title: '商品数量',
          dataIndex: 'productCount',
          key: 'productCount',
          align: 'center',
          render: (text, record, index) => (
            <div className='product-count-box' style={{ display: 'flex' }}>
              <span>{ record.productCount }</span>
              <Tag style={{ display: record.orderStatusName == '部分发货' ? 'block' : 'none', marginLeft: '10px' }}>
                { record.sendCount ? record.sendCount : 0 }/{ record.productCount ? record.productCount : 0 }已发货
              </Tag>
            </div>
          )
        },
        {
          title: '实付金额',
          dataIndex: 'payAmount',
          key: 'payAmount',
          align: 'center'
        },
        {
          title: '订单备注',
          dataIndex: 'buyerRemark',
          key: 'buyerRemark',
          align: 'center'
        },
        {
          title: '购买人姓名',
          dataIndex: 'buyerName',
          key: 'buyerName',
          align: 'center'
        },
        {
          title: '购买人电话',
          dataIndex: 'buyerPhone',
          key: 'buyerPhone',
          align: 'center'
        },
        {
          title: '操作',
          key: 'action',
          align: 'center',
          width: 140,
          fixed: 'right',
          render: (text, record) => (
            <Space>
              <AuthComponent authKey='/order-delivery/detail/{orderNo}'>
                <Button
                  type='link'
                  onClick={() => optionsHandler(record, 'detail')}>
                  查看
                </Button>
              </AuthComponent>
              <AuthComponent authKey='/order-delivery/delivery'>
                <Button
                  type='link'
                  onClick={() => optionsHandler(record, 'shipments')}>
                  发货
                </Button>
              </AuthComponent>
            </Space>
          )
        }
      ])
    } else {
      setColumns([
        {
          title: '配送方式',
          dataIndex: 'receiveWay',
          key: 'receiveWay',
          align: 'center'
        },
        {
          title: '订单号',
          dataIndex: 'orderNo',
          key: 'orderNo',
          align: 'center'
        },
        /* {
          title: '发货方式',
          dataIndex: 'deliveryWay',
          key: 'deliveryWay',
          align: 'center',
          render: (text, record) =>
            text == 'STORE'
              ? '门店发货'
              : text == 'MERCHANT'
              ? '供应商发货'
              : text
        },
        {
          title: '快递公司',
          dataIndex: 'deliveryCompany',
          key: 'deliveryCompany',
          align: 'center'
        },
        {
          title: '物流单号',
          dataIndex: 'deliveryCode',
          key: 'deliveryCode',
          align: 'center'
        }, */
        {
          title: '订单类型',
          dataIndex: 'orderTypeName',
          key: 'orderTypeName',
          align: 'center'
        },
        {
          title: '下单时间',
          dataIndex: 'orderTime',
          key: 'orderTime',
          align: 'center'
        },
        {
          title: '收货人姓名',
          dataIndex: 'receiverName',
          key: 'receiverName',
          align: 'center'
        },
        {
          title: '收货人电话',
          dataIndex: 'receiverPhone',
          key: 'receiverPhone',
          align: 'center'
        },
        {
          title: '收货地址',
          dataIndex: 'receiverDetailAddr',
          key: 'receiverDetailAddr',
          align: 'left'
        },
        {
          title: '商品数量',
          dataIndex: 'productCount',
          key: 'productCount',
          align: 'center'
        },
        {
          title: '实付金额',
          dataIndex: 'payAmount',
          key: 'payAmount',
          align: 'center'
        },
        {
          title: '订单备注',
          dataIndex: 'buyerRemark',
          key: 'buyerRemark',
          align: 'center'
        },
        {
          title: '购买人姓名',
          dataIndex: 'buyerName',
          key: 'buyerName',
          align: 'center'
        },
        {
          title: '购买人电话',
          dataIndex: 'buyerPhone',
          key: 'buyerPhone',
          align: 'center'
        },
        {
          title: '操作',
          key: 'action',
          align: 'center',
          width: 140,
          fixed: 'right',
          render: (text, record) => (
            <Space>
              <AuthComponent authKey='/order-delivery/detail/{orderNo}'>
                <Button
                  type='link'
                  onClick={() => optionsHandler(record, 'detail')}>
                  查看
                </Button>
              </AuthComponent>
              {/* {record.orderStatus === 'wait_take' && (
                <AuthComponent authKey='/order-delivery/update-delivery'>
                  <Button
                    type='link'
                    onClick={() => optionsHandler(record, 'edit')}>
                    修改单号
                  </Button>
                </AuthComponent>
              )} */}
            </Space>
          )
        }
      ])
    }
  }, [type])
  return (
    <Table
      size='middle'
      rowSelection={rowSelection}
      loading={loading}
      bordered
      scroll={{ x: 1800 }}
      columns={columns}
      dataSource={dataSource}
      rowKey='orderNo'
      pagination={{
        showQuickJumper: true,
        showSizeChanger: true,
        pageSize: page.pageSize,
        current: page.pageIndex,
        total,
        showTotal: total => `当前条件共检索到 ${total} 条信息`,
        onChange: (pageIndex, pageSize) => onChange({ pageIndex, pageSize })
      }}
    />
  )
}
export default ShipmentListTable
